import { render, staticRenderFns } from "./FormWizardNextButton.vue?vue&type=template&id=bed1d86a&"
import script from "./FormWizardNextButton.vue?vue&type=script&lang=ts&"
export * from "./FormWizardNextButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports